import pick from "lodash.pick";
import { INPUT_NAMES } from "../utils/config";

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

const validators = {
	presence(value, options) {
		if (value === undefined || value === null || (String(value).trim() === "" && !options.allowEmpty)) {
			return options.message;
		}
	},
	email(value, options) {
		if (value !== undefined && value !== null && value !== "" && !EMAIL_REGEX.test(value)) {
			return options.message;
		}
	},
	uuid(value, options) {
		if (!value || value === "") {
			return;
		}
		if (!UUID_REGEX.test(value)) {
			return options.message || "validation.uuidFormat";
		}
	},
};

const constraints = {
	[INPUT_NAMES.email]: {
		presence: {
			allowEmpty: false,
			message: "validation.email",
		},
		email: {
			message: "validation.email",
		},
	},
	[INPUT_NAMES.firstName]: {
		presence: {
			allowEmpty: false,
			message: "validation.firstName",
		},
	},
	[INPUT_NAMES.lastName]: {
		presence: {
			allowEmpty: false,
			message: "validation.lastName",
		},
	},
	[INPUT_NAMES.name]: {
		presence: {
			allowEmpty: false,
			message: "validation.name",
		},
	},
	[INPUT_NAMES.phoneNumber]: {
		presence: {
			allowEmpty: false,
			message: "validation.phone",
		},
	},
	[INPUT_NAMES.company]: {
		presence: {
			allowEmpty: false,
			message: "validation.company",
		},
	},
	[INPUT_NAMES.recaptcha]: {
		presence: {
			allowEmpty: false,
			message: "validation.recaptcha",
		},
	},
	[INPUT_NAMES.tenantId]: {
		uuid: {},
	},
	[INPUT_NAMES.tenantAdminId]: {
		uuid: {},
	},
};

// removing the parens creates an ambiguous arrow error
// eslint-disable-next-line no-extra-parens
export const isValid = errObj => (errObj ? false : null);

export default inputs => {
	const filteredConstraints = pick(constraints, Object.keys(inputs));
	const errors = {};

	Object.keys(filteredConstraints).forEach(field => {
		const fieldConstraints = filteredConstraints[field];
		Object.keys(fieldConstraints).forEach(validatorName => {
			const options = fieldConstraints[validatorName];
			const error = validators[validatorName](inputs[field], options);
			if (error) {
				if (!errors[field]) {
					errors[field] = [];
				}
				errors[field].push(error);
			}
		});
	});

	return Object.keys(errors).length > 0 ? errors : undefined;
};
